import { apiGet, apiSend } from './client';
import type { ReportContentReport, ReportSummary } from './types';

export async function fetchContentReports() {
  const data = await apiGet<{ reports: ReportContentReport[] }>('/admin/content-reports');
  return data.reports;
}

export async function resolveContentReport(id: string, input: { action?: 'resolve' | 'markInvalid' | 'hide' | 'restore'; moderatorNote?: string }) {
  const data = await apiSend<{ report: ReportContentReport }>(`/admin/content-reports/${encodeURIComponent(id)}/resolve`, 'POST', input);
  return data.report;
}

export async function dismissContentReport(id: string, moderatorNote?: string) {
  const data = await apiSend<{ report: ReportContentReport }>(`/admin/content-reports/${encodeURIComponent(id)}/dismiss`, 'POST', { moderatorNote });
  return data.report;
}

export async function restoreDeletedReport(id: string, moderatorNote?: string) {
  const data = await apiSend<{ report: ReportSummary }>(`/admin/reports/${encodeURIComponent(id)}/restore`, 'POST', { moderatorNote });
  return data.report;
}
